// RazorpayButton.js

import React, { useEffect, useRef, useState } from "react";
import { Accordion, AccordionSummary, Typography, Box, Grid, Card, Button, Tab, Tabs, } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import PersonIcon from "@mui/icons-material/Person";
import DoneIcon from '@mui/icons-material/Done';
import RemoveIcon from "@mui/icons-material/Remove";
import { DecorativeCorner } from "../../../common/DecorativeCorner";
import { styles } from "../../../styles/styles";
import Header from "../../Header";
import { matrimoneyEndPoints } from "../../../../services/apis";
import axios from "axios";
import { showError, showSuccess } from "../sweetAlert/sweetAlert";
import PlanCard from '../../PlanCard';
import { useNavigate } from "react-router-dom";
import { FontStyles } from "../../../styles/FontStyles";
const RazorpayButton = ({ amount }) => {
  let apiCall = useRef(false)
  const [selectedTab, setSelectedTab] = useState(0);
  let userType = sessionStorage.getItem("userType")
	let token
	if(userType){
		token = sessionStorage.getItem("token");
	}else{
		 token = localStorage.getItem("token");
	}
  const [customerPlans, setCustomerPlans] = useState([])
  const profile = localStorage.getItem("profileData");
  const storedProfileData = JSON.parse(profile)
  const navigate = useNavigate(); // Initialize navigate
  const [plans,setPlans] = useState([])
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    const selectedCategory = customerPlans[newValue];
    setPlans(selectedCategory?.plans)
  };
  const detalies = Array(6).fill({
    id: 1,
    name: "Access to all basic features"
  })
  const getCustomerPlans = async () => {
    try {
      const response = await axios.get(
        matrimoneyEndPoints.CUSTOMER_PLANS,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status) {
        setCustomerPlans(response.data?.data);
        setPlans(response.data?.data[0]?.plans)
      } else {
        setCustomerPlans([])
      }
    } catch (error) {
      console.error("GET_HEALTH_CONDITION_LIST API ERROR:", error);
    }
  }
  useEffect(() => {
    if (!apiCall.current) {
      apiCall.current = true
      getCustomerPlans()
    }
  })
  const loadRazorpay = async (planId) => {
    // Optional: Fetch order from your backend
    const data = await axios.post(matrimoneyEndPoints.CREATE_ORDER, { planId: planId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

    if (data && data?.data && data?.data.status) {
      const options = {
        key: "rzp_test_dxrCt5ZPpT9H0g", // replace with your Razorpay Key ID
        amount: data?.data?.data?.amount, // amount in paise (₹100)
        currency: "INR",
        name: "Annapurna Marriages",
        description: "Plan Subscription",
        order_id: data?.data?.data?.id, // uncomment this if using backend-generated order
        handler: async function (response) {
          try {
            const verifyPayment = await axios.post(
              matrimoneyEndPoints.VERIFY_PAYMENT,
              {
                "razorpay_order_id": response.razorpay_order_id,
                "razorpay_payment_id": response.razorpay_payment_id,
                "razorpay_signature": response.razorpay_signature
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json",
                },
              }
            );

            if (verifyPayment.data.status) {
              showSuccess(verifyPayment.data.message)
              navigate("/profile/DetaliesDashbord?type=suggested-profiles");
            } else {
              showError(verifyPayment.data.message)
            }
          } catch (error) {
            console.error("GET_HEALTH_CONDITION_LIST API ERROR:", error);
          }
          // console.log("Payment ID:", response.razorpay_payment_id);
          // console.log("Order ID:", response.razorpay_order_id);
          // console.log("Signature:", response.razorpay_signature);

        },
        prefill: {
          name: `${storedProfileData?.firstName} ${storedProfileData?.lastName}`,
          email: storedProfileData?.email,
          contact: storedProfileData?.mobile,
        },
        notes: {
          address: "Your Company Address",
        },
        theme: {
          color: "#3399cc",
        },
      };

      // console.log("options..............", options)

      const rzp = new window.Razorpay(options);
      rzp.open();
    } else {
      alert(data?.data?.message)
    }


  };

  // return <button onClick={loadRazorpay}>Pay ₹{amount}</button>;
  return (
    <Box>
      <Header />
      <Box sx={{ marginTop: { xs: "20%", sm: "10%" } }}>

        <Card
          sx={{
            ...styles.newCard,
            height: { xs: "auto", sm: 'auto' },
            width: "90%",
            borderRadius: "5px"
          }}
        >
          <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
          <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
          <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
          <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
          <Typography variant="h4" component="h1" sx={styles.heading}>
            Matrimony Privilege Plans
          </Typography>
          <Box sx={{
            width: "100%",
            margin: "auto",
            backgroundColor: "white",
            border: "2px solid #c1721f",
            padding: { xs: "10px", sm: "20px " },
            borderRadius: "10px",
            boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)",
          }}>
            <Box sx={styles.tabsContainerStyles}>
              <Tabs
                value={selectedTab}
                onChange={handleTabChange}
                sx={{
                  // ...styles.tabsStylespay,
                  "& .MuiTab-root": {
                    fontSize: { xs: "0.75rem", sm: "20px",xxl:"30px" },
                    minWidth: "auto",
                    flexShrink: 1,
                  },
                }}
                variant="scrollable"
                scrollButtons="auto"
              >
            {(customerPlans && customerPlans.length >0) && customerPlans.map((category, index) => (
              <Tab 
                key={category.id} 
                label={category.categoryName} 
                sx={styles.tabStylespay} 
              />
            ))}
          </Tabs>
            </Box>
            <Grid container gap={8} justifyContent="center">
              {(plans && plans.length > 0) && plans.map((each) => {
                return (
                  <Grid xs={12} sm={3} md={3}>
                    <Box
                      sx={{
                        border: "1px solid #c1721f",
                        borderRadius: "15px",
                        padding: { xs: 2, md: 3 },
                        justifyContent:"center",
                        display: "flex",
                        flexDirection: "column",
                        width: { xs: "100%", sm: "260px", md: "303px",xxl:"500px" },
                        margin: { xs: "0 auto", md: 0 },
                        maxWidth: "100%",
                        fontFamily: '"Inter var"', 
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Typography 
                         sx={{...FontStyles.razorpay}}>
                          {each.planName}
                        </Typography>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            backgroundColor: "#f8e9c8",
                            borderRadius: "15px",
                            padding: "2px 8px",
                          }}
                        >
                          <PersonIcon sx={{ fontSize: {sm:"0.9rem",xxl:"30px"}, mr: 0.5, color: "#8a6d3b" }} />
                          <Typography
                            variant="body2"
                            sx={{
                              color: "#8a6d3b", fontSize: { xs: '16px', sm: "0.9rem" ,xxl:"30px"}, fontFamily: '"Inter var"', 
                            }}
                          >
                            {each.noOfContacts}
                          </Typography>
                        </Box>
                      </Box>
                      <Box sx={{ mb: 2, width: "100%" }}>
                        <Typography component="span" variant="h6" sx={{ ...styles, fontSize: { xs: '16px', sm: '20px',xxl:"30px" }, fontFamily: '"Inter var"',  }}>
                          ₹ {each.planAmount} /
                        </Typography>
                        <Typography component='span' sx={{
                          ml: 1,
                          fontSize: { xs: '16px', sm: '20px',xxl:"30px", fontFamily: '"Inter var"', }
                        }}>
                          {each.duration} {each.durationType}
                        </Typography>
                      </Box>
                      {(each?.features && each?.features.length > 0) && each.features.map((paydetalies) => (
                        <Box
                          key={paydetalies.id}
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            marginBottom: '8px'
                          }}
                        >
                          <Box
                            sx={{
                              backgroundColor: '#c1721f',
                              padding: '5px',
                              width:{sm: "20px",xxl:"30px"},
                              height: {sm: "20px",xxl:"30px"},
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              borderRadius: '4px'
                            }}
                          >
                            <DoneIcon sx={{ color: 'white', fontSize: {sm:"15px" ,xxl:"30px"}}} />
                          </Box>
                          <Typography
                          sx={{ fontSize: {sm:"20px" ,xxl:"30px",fontWeight:400,   fontFamily: '"Inter var"', }}}>{paydetalies.name}</Typography>
                        </Box>
                      ))}

                      <Button onClick={() => loadRazorpay(each.id)} variant="contained"
                        sx={{
                         ...FontStyles.paybutton
                        }}
                      >
                        Pay Now
                      </Button>
                    </Box>
                  </Grid>
                )
              })}
            </Grid>
          </Box>
        </Card>
      </Box>
    </Box>)
};

export default RazorpayButton;
